import * as React from "react";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import Container from "@mui/material/Container";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import AddIcon from "@mui/icons-material/Add";
import SyncIcon from "@mui/icons-material/Sync";
import { getApiCall, postApiCall } from "../../../services/apiHelper";
import { DashboardService } from "../../../services/DashboardService";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  GridActionsCellItem,
  GridToolbarFilterButton,
  GridPaginationModel,
  GridFilterModel,
  GridColDef,
  GridToolbarContainer,
  GridToolbarExport,
  getGridStringOperators,
  GridDeleteIcon,
  GridRowSelectionModel,
  GridLogicOperator,
} from "@mui/x-data-grid-pro";
import { DataGrid } from "../../util/DataGrid";
import "./UserRoleMapDashboard.css";
import { DeleteForever } from "@mui/icons-material";
import { wait } from "@testing-library/user-event/dist/utils";
import { TaskmgmtServiceURL } from "../../../config/config";
import { ServiceName } from "../../../constants";
import { AlertDialog } from "../../util/Dialog";
import { ToastMessage } from "../../util/ToastMessage";
import { useResizeDetector } from "react-resize-detector";

export interface UserRole {
  id: string;
  role: string;
  userName: string;
  email: string;
  fund: string;
  investmentType: string;
  status: string;
  userType: string;
  region: string;
}

const UserRoleMapDashboard = () => {
  const navigate = useNavigate();
  const value = React.useRef("All Items");

  const [rowSelectionModel, setRowSelectionModel] = useState<GridRowSelectionModel>([]);
  const [userRolesData, setUserRolesData] = useState<UserRole[]>([]);
  const [pageSize, setPageSize] = useState<number>(10);
  const [loading, setLoading] = useState<boolean>(false);
  const singleDelete = React.useRef(false);
  const [openDialog, setOpenDialog] = useState<boolean>(false);
  const [toBeDeleteId, setToBeDeleteId] = useState<string>("");
  const [isError, setIsError] = useState<{ isError: boolean; message: string }>(
    { isError: false, message: "" }
  );
  const [isSuccess, setIsSuccess] = useState<{
    isSuccess: boolean;
    message: string;
  }>({ isSuccess: false, message: "" });
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: pageSize,
  });
  const [filterModel, setFilterModel] = React.useState<GridFilterModel>({
    items: [],
    logicOperator:GridLogicOperator.And
  });
  const [rowCount, setRowCount] = useState<number>(0);
  const dashboardService = new DashboardService();

  const { width,ref } = useResizeDetector();
  const [columnWidths,setColumnWidths] = useState<any>({});

  useEffect(()=>{
    if(width){
      const newColumnWidths = {
        column1:width * 0.1,
        column2:width * 0.15,
      };
      setColumnWidths(newColumnWidths);
    }
  },[width]);
  
  const formatNumber = (params:any) => {
    if(params.value !== null)
      return<div style={{textAlign:'right',width:'85%',paddingRight:'5px'}}>
        {params.value.toLocaleString('en-US')}
      </div>
     ;
  }

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    console.log(newValue);
    value.current = newValue;
    sessionStorage.setItem("SessionUserRoleMapDashboardView", newValue)
    fetchData(paginationModel, filterModel);
  };
  const fetchData = async (paginationModel: GridPaginationModel, filterModel: GridFilterModel) => {
    if (value.current == "All Items") {
      try {
        setLoading(true);
        await dashboardService.getUserRoleMap(paginationModel, filterModel).then(
          (data: any) => {
            console.log(data);
            setUserRolesData(data.result.userRole);
            setRowCount(data.result.rowCount);
          }
        );
      } catch (e) {
        console.log(e);
      }
      finally {
        setLoading(false);
      }
    }
    if (value.current == "To be Archived User Role") {
      try {
        setLoading(true);
        await dashboardService.getUserRoleMapToBeArchived(paginationModel, filterModel).then(
          (data: any) => {
            console.log(data);
            setUserRolesData(data.result.userRole);
            setRowCount(data.result.rowCount);
          }
        );
      } catch (e) {
        console.log(e);
      }
      finally {
        setLoading(false);
      }

    }
  };

  useEffect(() => {
    var view = sessionStorage.getItem("SessionUserRoleMapDashboardView");
    value.current = view != null ? view :"All Items";
    fetchData(paginationModel, filterModel);
  }, [paginationModel, filterModel]);

  console.log(userRolesData);

  const cols:any[] = [
    {
      field: "role", header: "Role"
    },
    {
      field: "userName", header: "User Name"
    },
    {
      field: "email", header: "Email"
    },
    {
      field: "fundId", header: "Fund Id"
    },
    {
      field: "fundName", header: "Fund Name"
    },
    {
      field: "investmentType", header: "Investment Type"
    },
    {
      field: "firm", header: "Firm"
    },
    {
      field: "firstName", header: "Firs tName"
    },
    {
      field: "lastName", header: "Last Name"
    },
    {
      field: "status", header: "Status"
    },
    {
      field: "userType", header: "User Type"
    },
    {
      field: "region", header: "Region"
    }
  ]

  const columns: GridColDef[] = [
    {
      field: "action",
      headerName: "Actions",
      sortable: false,
      filterable: false,
      disableExport: true,
      renderCell: (cellValues) => {
        const onEditClick = (e: any) => {
          e.stopPropagation(); // don't select this row after clicking
          navigate("/userrolemap/" + "edit/" + cellValues.id);
          return console.log("EDIT  >>>>", cellValues.id);
        };

        const onViewClick = (e: any) => {
          e.stopPropagation();// don't select this row after clicking
          navigate("/userrolemap/" + "view/" + cellValues.id);
          return console.log("View  >>>>", cellValues);
        };

        const onDeleteClick = (e: any) => {
          console.log(cellValues);
          setToBeDeleteId(cellValues.id.toString());
          singleDelete.current = true;
          openConfirmBox();
          e.stopPropagation();
        }
        return (
          <>
            <GridActionsCellItem
              sx={{
                color: "#253746",
              }}
              icon={<VisibilityIcon />}
              label="View"
              onClick={(event) => {
                onViewClick(event);
              }}
            />
            <GridActionsCellItem
              sx={{
                color: "#253746",
              }}
              icon={<EditIcon />}
              label="Edit"
              onClick={(event) => {
                onEditClick(event);
              }}
            />

            {value.current == "To be Archived User Role" && <GridActionsCellItem
              sx={{
                color: "#253746",
              }}
              icon={<GridDeleteIcon />}
              label="Edit"
              onClick={(event) => {
                onDeleteClick(event);
              }}
            />}
          </>
        );
      },
      width:columnWidths.column1 || 100,
    },
    {
      field: "role", headerName: "Role", width:columnWidths.column2 || 100,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      )
    },
    {
      field: "userName", headerName: "User Name", width:columnWidths.column2 || 100,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      )
    },
    {
      field: "email", headerName: "Email", width:columnWidths.column2 || 100,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      )
    },
    {
      field: "fundName", headerName: "Fund", width:columnWidths.column2 || 100,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      )
    },
    {
      field: "investmentType", headerName: "Investment Type", width:columnWidths.column2 || 100,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      )
    },
    {
      field: "status", headerName: "Status", width:columnWidths.column2 || 100,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      )
    },
    {
      field: "userType", headerName: "User Type", width:columnWidths.column2 || 100,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      )
    },
    {
      field: "region", headerName: "Region", width:columnWidths.column2 || 100,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      )
    },
  ];

  const handelPaginationModel = (e: any) => {
    setPaginationModel(e);
    fetchData(e, filterModel);
    console.log(e);
  };

  const handelFilterModelChange = (model: GridFilterModel) => {
    // const count = model?.items.length != 0 ? Object.keys(model?.items[0]).length-1 : 0;
    // if (count === 4) {
    setFilterModel(model);
    fetchData(paginationModel, model);
    // }
    console.log(model);
  };

 

  const transformData = (data:any[],columnNames:any[]) => {
    return data.map(row => {
      const formattedRow: {[key: string] : string | number} = {};
      columnNames.forEach(col => {
        formattedRow[col.header] = row[col.field];
      });
      return formattedRow;
    });
  };

  const handleExport = async () => {
    var paginationModelNew = {...paginationModel};
    paginationModelNew.pageSize = 20000;
    const dataToExport =  await dashboardService.getUserRoleMap(paginationModelNew, filterModel).then(
      (data: any) => {return data.result.userRole;
      });
    
    const data = transformData(dataToExport,cols);

    const csvData = convertToCSV(data);
    downloadCSV(csvData);
  };


  // Function to convert the transformed data to CSV format
const convertToCSV = (data: { [key: string]: string | number }[]) => {
  const headers = Object.keys(data[0]).join(',');
  const rows = data.map((row) =>
    Object.values(row)
      .map(value => `"${value}"`)
      .join(',')
  );
  return [headers, ...rows].join('\n');
};

// Function to trigger the CSV download
const downloadCSV = (csvData: string) => {
  const blob = new Blob([csvData], { type: 'text/csv' });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = 'data.csv';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};




  const CustomToolbar = () => {
    return (
      <GridToolbarContainer>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <Button onClick={handleExport}>Export Data</Button></div>
        <GridToolbarFilterButton />
        {(value.current == "To be Archived User Role" && rowSelectionModel.length != 0) && <Button sx={{textTransform:"none"}}
          variant="text"
          startIcon={<GridDeleteIcon />}
          onClick={openConfirmBox}
        >
          Delete & Archive
        </Button>}
      </GridToolbarContainer>
    );
  };

  const closeDialog = () => {
    setToBeDeleteId("");
    setOpenDialog(false);
  };

  const openConfirmBox = () => {
    setOpenDialog(true);
  };

  const DeleteUserRoleMap = () => {

    var ids: string[] = [];

    if (singleDelete.current) {
      ids.push(toBeDeleteId);
    } else {
      rowSelectionModel.forEach((id: any) => {
        ids.push(id.toString());
      })
    }
    console.log(ids);
    try {
      setOpenDialog(false);
      setLoading(true);
      postApiCall(
        TaskmgmtServiceURL + "/userrolemaps/delete",
        ids,
        ServiceName.TASKMANAGEMENTSERVICE
      )
        .then((res: any) => {
          setIsSuccess({
            isSuccess: true,
            message: "User Role Map is Deleted",
          });
          var userRoles = [...userRolesData];
          var count = 0;
          ids.forEach((id:string) => {
            const i = userRolesData.findIndex((data:UserRole) => data.id == id);
            count++;
            userRoles.splice(i,1);
            // console.log(userRoles.splice(i,1));
           
          })
          setRowCount(rowCount-count);
          setUserRolesData(userRoles);
          // if (singleDelete.current) {

          //   userRolesData.splice(userRolesData.findIndex((data:any) => data.id == toBeDeleteId),1)
          //   ids.push(toBeDeleteId);
          // } else {
          //   rowSelectionModel.forEach((id: any) => {
          //     ids.push(id.toString());
          //   })
          // }
          // userRolesData

        })
        .catch((error: any) => {
          console.log(error);
          setIsError({
            isError: true,
            message: error.response?.data.responseException.exceptionMessage,
          });
        });
    } catch (error) {
      console.log(error);
    } finally {
      if (singleDelete.current) {
        singleDelete.current = false;
      }
      wait(1000).then(() => {
        setLoading(false);
      });
      setIsSuccess({
        isSuccess: false,
        message: "",
      });
      setIsError({
        isError: false,
        message: "",
      });
    }
  };


  const callDeltaFromAzure = () =>{
    try{
    console.log(TaskmgmtServiceURL);
    getApiCall(TaskmgmtServiceURL + "/userrolemaps/DeltaUsersFromAzure", ServiceName.TASKMANAGEMENTSERVICE).then((data:any) => {
      alert(data.result);
    }).catch((error:any) => {
      alert(error);
    })}catch(error:any) {
      console.log(error);
    }
  }


  return (
    <Container maxWidth={false} className="dashboard-wrap">
      {
        <AlertDialog
          isOpen={openDialog}
          handleClose={closeDialog}
          onConfirm={DeleteUserRoleMap}
          title={"Attention"}
          message={"Are you sure you want to delete this record?"}
        />
      }
      {isError.isError && (
        <ToastMessage message={isError.message} severity="error" />
      )}
      {isSuccess.isSuccess && (
        <ToastMessage message={isSuccess.message} severity="success" />
      )}
      <Box ref={ref} sx={{ width: "100%", typography: "body1" }}>
        <TabContext  value={value.current}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <div className="user-role-action-btn head-action-btn text-right">
              <Button 
                variant="contained"
                color="success"
                sx={{textTransform:"none",marginRight: 3}} 
                onClick={() => callDeltaFromAzure()}
              >
                <SyncIcon /> Sync From Azure
              </Button>

              <Button sx={{textTransform:"none"}}
                variant="contained"
                color="success"
                onClick={() => navigate("/userrolemap/new")}
              >
                <AddIcon />
                New User Role
              </Button>
            </div>
            <TabList
              onChange={handleChange}
              aria-label="Appraisals Tab"
              variant="scrollable"
              scrollButtons="auto"
            >
              <Tab label="All Items" value="All Items" sx={{textTransform:'capitalize'}}/>
              <Tab label="To be Archived User Role" value="To be Archived User Role" sx={{textTransform:'capitalize'}} />
            </TabList>
          </Box>
          <TabPanel  value="All Items">

            <DataGrid
              rows={userRolesData}
              rowCount={rowCount}
              columns={columns}
              paginationModel={paginationModel}
              PaginationModelChange={handelPaginationModel}
              filterModel={filterModel}
              loading={loading}
              filterModelChange={(model: GridFilterModel) => handelFilterModelChange(model)}
              customToolbar={CustomToolbar}

            />

          </TabPanel>
          <TabPanel value="To be Archived User Role">

            <DataGrid
              rows={userRolesData}
              columns={columns}
              rowCount={rowCount}
              paginationModel={paginationModel}
              PaginationModelChange={handelPaginationModel}
              filterModel={filterModel}
              loading={loading}
              filterModelChange={(model: GridFilterModel) => handelFilterModelChange(model)}
              customToolbar={CustomToolbar}
              checkboxSelection={true}
              onRowSelectionModelChange={(newRowSelectionModel: any) => {
                setRowSelectionModel(newRowSelectionModel);
              }}
              rowSelectionModel={rowSelectionModel}
            />

            

          </TabPanel>
        </TabContext>
      </Box>
    </Container>
  );
};

export default UserRoleMapDashboard;
